import { computed } from 'vue'
import { useUserStore } from '@/store/user'
import { useBrowserStateStore } from '@/store/browserState'
import { INavigationItem } from '@/types/INavigationItem'

/**
 * Builds the partner navigation items used in the top banner navigation bar.
 * Shared between the /partner route (via meta.banner.navigationItems factory in
 * router/index.ts) and shopping-cart.vue (named cart mode via direct URL).
 */
export function buildPartnerNavigation() {
    const userStore = useUserStore()
    const browserState = useBrowserStateStore()

    const isAdmin = computed(() => userStore.isAdmin)
    const showAdminLink = computed(() => isAdmin.value && !browserState.isSmallScreen)
    const showUsersLink = computed(() => userStore.mayViewPartnerUsers)

    const navigationItems = computed(() => [
        { textName: 'DeviceSupport', routeName: 'partner-sparepart-search' },
        { textName: 'MyDevices', routeName: 'partner-devices', align: 'right', replace: true },
        { textName: 'Users', routeName: 'partner-user-list', replace: true, condition: () => showUsersLink.value },
        { textName: 'contactSupport', routeName: 'partner-contact-support', replace: true },
        { textName: 'AdminMenu', routeName: 'admin', condition: () => showAdminLink.value }
    ] as INavigationItem[])

    return { navigationItems }
}
